export default {
    get admin_api() {
        let admin_api = base_url + '/admin/api';
        return {
            index: admin_api,
            get products() {
                let products_api = admin_api + '/products';
                return {
                    index: products_api
                };
            },
            get categories() {
                let categories_api = admin_api + '/categories';
                return {
                    index: categories_api,
                    products(category_id) {
                        return `${categories_api}/${category_id}/products`;
                    },
                    updateProducts(category_id) {
                        return `${categories_api}/${category_id}/update-products`;
                    }
                };
            }
        };
    }
};